<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="id"
      :col="3"
      :columns="tableColumns"
      :queryParams="queryParams"
      :searchOptions="tableSearchOptions"
      :requestPromise="loadData?loadData:loadDataList"
      :enableSearch="false"
      :operationBoxStyle="{padding: '0 0 16px'}"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建
      </a-button>
      <template v-slot:status="{text}">
        {{text==1?'运行中':'已屏蔽'}}
      </template>
      <template v-slot:action="{record}" >
        <a-space>
          <a @click="onEditEvent(record)">编辑</a>
          <a @click="onSwitchStatus(record)">{{ record.status == 1 ? '屏蔽' : '解除屏蔽' }}</a>
        </a-space>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem?'编辑规则':'新增规则'"
      @cancel="showDialog = false"
      @ok="onEditResultEvent"
    >

      <template v-slot:header="formData">
        <a-card :bordered="false" :bodyStyle="{padding:'10px 0'}">
          <template v-slot:title>
            <span style="font-size: 14px">价格规则</span>
          </template>
          <template v-slot:extra>
            <span>提示：结算价格，指自我游给分销商的分销价格；零售价，指自我游显示的抢购价格；</span>
          </template>
          <div class="custom-header-box">
            <span>本系统</span>
            <span class="right-span">自我游价格</span>
            <br/>
            <span >同行价</span>
            <span class="right-span">结算价格+(零售价-结算价格)*同行价费率({{formData.peerPriceRate?formData.peerPriceRate:0}}%)</span>
            <br/>
            <span>佣金价</span>
            <span class="right-span">(零售价-结算价格)*佣金价费率({{formData.commissionRate?formData.commissionRate:0}}%)</span>
            <br/>
            <span>市场价</span>
            <span class="right-span">市场价格</span>

            <br/>
            <span>采购价</span>
            <span class="right-span">结算价格</span>
          </div>
        </a-card>
      </template>
     <template v-slot:peerPriceRate="{form}">
       <span>结算价格+(零售价-结算价格)*<a-input-number
         v-model="form.peerPriceRate"
         :min="0"
       ></a-input-number>%</span>
     </template>
     <template v-slot:commissionRate="{form}">
       <span>(零售价-结算价格)*<a-input-number
         v-model="form.commissionRate"
         :min="0"
       ></a-input-number>%</span>
     </template>
    </SimpleFormEditorDialog>
  </div>
</template>

<script>
import SearchMixins from '../../mixins/SearchMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import ZwyMiXins from '@/views/resource/zwy/mixins/ZwyMiXins'
import ValidatorHelper from '@/utils/helper/validatorHelper'

export default {
  name: 'TaskListComponent',
  mixins:[SearchMixins,ZwyMiXins],
  props:{
    proJoinType:{
      type:String,
      default:''
    },
    columns:{
      type:Array,
      default:()=>[]
    },
    searchOptions:{
      type:Array,
      default:()=>[]
    },
    loadData:{
      type:Function,
      default:undefined
    }
  },
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {
      },
      associateAccountList:[],
      localSearchOptions: [
        {
          name: '自我游ID',
          key: 'productNo',
          type: 'input',
          placeholder: '请输入商品ID'
        },
        {
          name: '商品名称',
          key: 'productName',
          type: 'input',
          placeholder: '请输入商品名称'
        },
        {
          name: '自我游类目',
          type: 'select',
          key: 'joinType',
          placeholder: '请选择',
          selectOptions: []
        },
        {
          name: '屏蔽日期',
          key: 'shieldTimeStart,shieldTimeEnd',
          type: 'rangePicker',
        },
      ],
      showDialog:false,
      selectItem: undefined,
      editConfigList: [
        {
          name: '同行价',
          key: 'peerPriceRate',
          placeholder: '请输入同行价费率(%)',
          type: 'slot'
        },
        {
          name: '佣金',
          key: 'commissionRate',
          placeholder: '请输入佣金费率(%)',
          type: 'slot'
        },
        {
          name: '来源账号ID',
          key: 'distributorIds',
          mode:'multiple',
          placeholder: '请选择来源账号ID',
          selectOptions: []
        },
        {
          name: '商品信息更新间隔(分钟)',
          key: 'productSyncInterval',
          placeholder: '请输入商品信息更新间隔(分钟)',
        },
        {
          name: '商品信息策略',
          key: 'productSyncStrategy',
          placeholder: '请选择商品信息策略',
          radioOptions:[
            {
              value: 0,
              label: '每次更新'
            },
            {
              value: 1,
              label: '仅首次更新'
            }
          ]
        },
        {
          name: '价格库存更新间隔(分钟)',
          key: 'priceSyncInterval',
          placeholder: '请输入价格库存更新间隔(分钟)',
        },
        {
          name: '价格库存策略',
          key: 'priceSyncStrategy',
          placeholder: '请选择价格库存策略',
          radioOptions:[
            {
              value: 0,
              label: '每次更新价格库存'
            },
            {
              value: 1,
              label: '仅更新库存不更新价格'
            }
          ]
        },
        {
          name: '同步类型',
          key: 'syncType',
          placeholder: '请选择同步类型',
          radioOptions:[
            {
              value: 0,
              label: '全量同步'
            },
            {
              value: 1,
              label: '指定商品'
            }
          ]
        },
        {
          name: '指定产品',
          key: 'productNos',
          type:'textarea',
          placeholder: '请输入自我游产品ID，一行一个',
          useFun:function(formData){
            return formData['syncType']==1;
          }
        },
      ],
      rules: {
        distributorIds: [{ required: true, message: '请选择来源账号', trigger: 'change' }],
        peerPriceRate: ValidatorHelper.createPositiveNumberRule(true, '请输入同行价费率(%)', '格式有误,必须是2位小数以内的正数',true),
        commissionRate: ValidatorHelper.createPositiveNumberRule(true, '请输入佣金费率(%)', '格式有误,必须是2位小数以内的正数',true),
        priceSyncInterval: ValidatorHelper.createPositiveNumberRule(true, '请输入价格库存更新间隔(分钟)', '格式有误,必须是2位小数以内的正数'),
        productSyncInterval: ValidatorHelper.createPositiveNumberRule(true, '请输入价格库存更新间隔(分钟)', '格式有误,必须是2位小数以内的正数'),
        productNos: [{ required: true, message: '请输入产品ID', trigger: 'change' },]
      },
    }
  },
  // watch: {
  //   'joinTypeList':function () {
  //     const thirdOption = this.searchOptions[2]
  //     thirdOption.selectOptions=this.joinTypeList
  //     this.$set(this.searchOptions,2,thirdOption)
  //   },
  // },
  computed:{
    tableColumns(){
      return this.columns&&this.columns.length>0?this.columns:this.getColumns()
    },
    tableSearchOptions(){
      return this.searchOptions&&this.searchOptions.length>0?this.searchOptions:this.localSearchOptions
    }
  },
  created() {
    this.getAssociateAccount();
  },
  mounted() {

  },
  methods: {
    getAssociateAccount() {
      const requestParams = {
        pageNum:1,
        pageSize:10000,
        status:1,
        proJoinType: this.proJoinType
      }
      return new Promise((resolve, reject) => {
        this.getHttpServices().getSourceService()
          .get('zwy/combo/queryAssociateAccount',requestParams)
          .then(res => {
            const list=res.data?res.data:[];
            if(list &&list.length>0){
              this.associateAccountList=list.map((item)=>{
                return {
                  label: item.supplierName,
                  value: item.id,
                }
              })
              const element = this.editConfigList[2]
              element.selectOptions=this.associateAccountList
              this.$set(this.editConfigList,2,element)
              resolve(list)
            }else {
              resolve([])
            }
          })
          .catch(reason => {
            console.error(reason)
            resolve([])
          })
      })
    },
    loadDataList(params) {
      const requestParams = this.getRequestParams(params)
      requestParams.joinType = this.proJoinType
      return this.getHttpServices().getSourceService().post('zwy/syncRule/list',requestParams)
    },
    getColumns(){
      return [
        {
          title: '规则ID',
          dataIndex: 'id',
          width: '80px',
        },
        {
          title: '规则信息',
          dataIndex: 'ruleInfo',
          width: '460px',
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '80px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '140px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    refreshData(reset){
      this.$refs.table?.refresh(reset)
    },
    onSwitchStatus(item){
      const params = {
        id: item.id,
      }
      const url= String(item.status) === '1'?'zwy/syncRule/shield':'zwy/syncRule/unshield'
      this.getHttpServices().getSourceService().get(url, params)
        .then(res => {
          this.refreshData(false)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          }else{
            this.$message.error('操作失败，请重试！')
          }
        })
    },
    onEditEvent(item){
      const url='zwy/syncRule/detail'
      this.getHttpServices().getSourceService().get(url, {id:item.id})
        .then(res=>{
          this.selectItem = {
            ...res,
            distributorIds:res.distributorIds.split(','),
            productNos:res.productNos?res.productNos.split(',').join('\n'):'',
            id:item.id,
          }
          this.showDialog = true;
        })
        .catch(reason => {
          this.$message.error('获取数据失败，请重试')
          console.error('==获取数据失败，请重试==',reason)
        })
    },

    async onAddEvent(){
      if(this.associateAccountList.length<1){
        const list= await this.getAssociateAccount()
        if(list.length<1){
          this.$message.error('请先创建可用的关联账号')
          return
        }
      }
      this.selectItem = {
        syncType:0,
        priceSyncStrategy:1,
        productSyncStrategy:1,
      }
      this.showDialog = true
    },
    onEditResultEvent(params){
      const url=params.id?'zwy/syncRule/update':'zwy/syncRule/create'
      const data={
        ...params,
        distributorIds:params.distributorIds.join(','),
        productNos:params.productNos?params.productNos.split(/[\r\n]+/).filter(i => !!i).map(i=>i.trim()).join(','):'',
        proJoinType: this.proJoinType
      }
      this.getHttpServices().getSourceService().post(url, data)
        .then(res => {
          this.showDialog = false
          this.selectItem = undefined
          this.$message.success('操作成功！')
          const isEdit=!!params.id
          this.refreshData(!isEdit);
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          }else{
            this.$message.error("操作失败，请重试！")
          }
          console.error(err)
        })
    }
  }
}
</script>

<style scoped>
.custom-header-box{
  width: 100%;
  box-sizing: border-box;
  padding-left: 90px;
  padding-bottom: 20px;
  .right-span{
    margin-left: 70px;
  }
}
</style>
